export const webAppUrl = "https://script.google.com/macros/s/AKfycbw6UJ-IyyjNoV2UJHg70js_J3qSuYd8lqoAlsbbMpeYfnUwByhblNA6o13wHLYact7J/exec"
